import { matchPath } from 'react-router-dom'
import Sqids from 'sqids'

export const HAVEN_PATH = '/haven'
export const HAVEN_CONVERSATION_PATH = `${HAVEN_PATH}/:conversationId`
export const HAVEN_FALLBACK_RETURN_PATH = '/dashboard'
export const OPEN_HAVEN_QUERY_PARAM = 'openHaven'
export const HAVEN_CONTEXT_QUERY_PARAM = 'havenContext'
export const HAVEN_ENTRY_QUERY_PARAM = 'havenEntry'
export const HAVEN_VIEW_QUERY_PARAM = 'havenView'
export const INVALID_CONVERSATION_ID = 'invalid'

type UrlConversation = number | typeof INVALID_CONVERSATION_ID | null

// Letters and digits minus look-alikes (0 O o 1 I l i). Never change it: every link already sent would break.
const HAVEN_CONVERSATION_ID_ALPHABET =
  'jvk6rdQSseTAcLfqn4UxG7Zm2uJXbPH5DN3RCV9M8FpagYBzWEyhKtw'

const conversationIds = new Sqids({
  alphabet: HAVEN_CONVERSATION_ID_ALPHABET,
  minLength: 6,
})

export interface HavenRouteState {
  havenReturnTo?: string
}

export const havenFullScreenPath = (conversationId?: number | null): string =>
  conversationId
    ? `${HAVEN_PATH}/${conversationIds.encode([conversationId])}`
    : HAVEN_PATH

export const isHavenPath = (pathname: string): boolean =>
  Boolean(
    matchPath(HAVEN_PATH, pathname) ||
    matchPath(HAVEN_CONVERSATION_PATH, pathname)
  )

export const readHavenReturnTo = (state: unknown): string | null => {
  if (typeof state !== 'object' || state === null) return null
  if (!('havenReturnTo' in state)) return null
  return typeof state.havenReturnTo === 'string' ? state.havenReturnTo : null
}

export const parseUrlConversation = (
  value: string | null | undefined
): UrlConversation => {
  if (value === null || value === undefined) return null
  const [id, ...rest] = conversationIds.decode(value)
  // Several strings decode to the same id; only the one we write is a link.
  const isLink =
    id > 0 && rest.length === 0 && conversationIds.encode([id]) === value
  return isLink ? id : INVALID_CONVERSATION_ID
}

/**
 * The search string without the one-shot launch params: the router's location can still carry
 * them after they were stripped, and writing them back relaunches Haven.
 */
export const withoutLaunchParams = (search: string): string => {
  const params = new URLSearchParams(search)
  params.delete(OPEN_HAVEN_QUERY_PARAM)
  params.delete(HAVEN_CONTEXT_QUERY_PARAM)
  params.delete(HAVEN_ENTRY_QUERY_PARAM)
  params.delete(HAVEN_VIEW_QUERY_PARAM)
  const next = params.toString()
  return next ? `?${next}` : ''
}
